{
  "projectName": "ParkingHubGestao",
  "projectLogo": "assets/Logomarca.svg",
  "projectLogoHome": "assets/logotipo-home.png",
  "projectColors": {
    "primary": "#466da0",
    "secondary": "#f36e25",
    "text-color": "#27272a",
    "menu-primary": "#466da0",
    "menu-secondary": "#3a5a84"
  },
  "permissionScreen": {
    "defaultPermission": false
  },
  "versionRelease": {
    "portal": "90"
  }
}
